import { Impulse, useScoped } from "~/tools/impulse";

/**
 * This impulse holds whether tooltip is enabled in the application.
 * It is initially false to avoid loading the heavy `@radix-ui/react-tooltip` library
 * until the user hovers of focuses a tooltip trigger.
 */
const isEnabled = Impulse(import.meta.env.MODE === "test");

export function useIsEnabled(): boolean {
	return useScoped((scope) => isEnabled.getValue(scope), []);
}

export function enable(): void {
	isEnabled.setValue(true);
}
